import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import { loadRuntimeConfig } from '@tsin-core/config/config.loader';
import { NgxsStoragePluginModule, StorageOption, withNgxsStoragePlugin } from '@ngxs/storage-plugin';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { AuthState } from '@tsin-core/states/auth.state';
import { CounterState } from '@tsin-core/states/counter.state';
import { environment } from '@tsin-env/environment';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { jwtInterceptor } from '@tsin-core/interceptors/jwt.interceptor';
import { loggingInterceptor } from '@tsin-core/interceptors/logging.interceptor';
import { FacilitatorState } from '@tsin-core/states/facilitator.state';
import { SessionState } from '@tsin-core/states/session.state';
import { CaseState } from '@tsin-core/states/case.state';
import { LearningProgramState } from '@tsin-core/states/learning.state';
import { TrackManagementState } from '@tsin-core/states/track-management.state';
import { ScheduleState } from '@tsin-core/states/schedule.state';
import { OrientationState } from '@tsin-core/states/orientation.state';
import { ApplicationState } from '@tsin-core/states/application.state';
import { UserState } from '@tsin-core/states/user.state';
import { UploadCSVState } from '@tsin-core/states/upload-csv.state';
import { AttendanceState } from '@tsin-core/states/attendance.state';
import { MakeupActivityState } from '@tsin-core/states/makeup-activity.state';
import { AssessmentState } from '@tsin-core/states/assessment.state';
import { ResultsState } from '@tsin-core/states/results.state';
import { SchoolsState } from '@tsin-core/states/schools.state';
import { SignUpState } from '@tsin-core/states/signup.state';
import { RECAPTCHA_V3_SITE_KEY, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { ConfirmationService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    // Load /assets/config.json before the app renders.
    // Charge /assets/config.json avant le rendu de l'application.
    {
      provide: APP_INITIALIZER,
      useFactory: loadRuntimeConfig,
      multi: true,
    },
    provideRouter(
      routes,
      withComponentInputBinding(),
      // withDebugTracing()
    ),
    importProvidersFrom(BrowserAnimationsModule),
    provideHttpClient(
      withInterceptors([jwtInterceptor, loggingInterceptor]),
    ),
    // Provide your reCAPTCHA v3 site key
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaSiteKey } as RecaptchaSettings,
    },
    // AppStoreModule)
    importProvidersFrom(
      NgxsModule.forRoot([
        AuthState,
        SignUpState,
        FacilitatorState,
        LearningProgramState,
        LearningProgramState,
        LearningProgramState,
        OrientationState,
        UploadCSVState,
        UserState,
        UserState,
        ApplicationState,
        ApplicationState,
        SessionState,
        CaseState,
        TrackManagementState,
        ScheduleState,
        AttendanceState,
        MakeupActivityState,
        AssessmentState,
        SchoolsState,
        ResultsState,
      ], {
        developmentMode: !environment.production
      }),
      NgxsStoragePluginModule.forRoot({ keys: ['authState.auth', 'authState.guest', 'signUpState', 'facilitatorState.facilitators', 'facilitatorState.selectedFacilitator', 'learningState.learningPrograms', 'learningState.selectedLearningProgram', 'learningState.userSelectedPrograms', 'orientationState.orientations', 'uploadCSVState.history', 'userState.users', 'userState.guests', 'applicationState.application', 'applicationState.selectApplication', 'applicationState.isUserHasRegistrations', 'assessmentState', 'resultState.results', 'resultState.selectedResult'] }),
      // storage: StorageOption.LocalStorage
      NgxsLoggerPluginModule.forRoot({
        disabled: environment.production
      }),
      NgxsReduxDevtoolsPluginModule.forRoot({
        disabled: environment.production
      }))
  ]
};
